import(/* webpackMode: "eager", webpackExports: ["FoundingVenuesMarketingPage"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/court-intelligence/founding-venues-marketing-page.tsx");
